export const SELECT_HABITAT = 'SELECT_HABITAT';
export const UPDATE_HABITAT_DATA = 'UPDATE_HABITAT_DATA';
export const TOGGLE_MAP_MODAL = 'TOGGLE_MAP_MODAL';
export const SET_EDIT_HABITAT = 'SET_EDIT_HABITAT';
